import authorizationManagementView from "../page/authorization-management/AuthorizationManagementView.vue";

export default {
  stationListView: [
    // NOTE: bir sayfaya yönlendirme yapılacaksa href yerine 'to' diyip route verilmeli
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "İstasyon Yönetimi",
      to: "/istasyon-yonetimi",
    },
    {
      text: "İstasyon Yönetimi",
      active: true,
    },
  ],
  stationCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "İstasyon Yönetimi",
      href: "#",
    },
    {
      text: "İstasyon Yönetimi",
      to: "/istasyon-yonetimi",
    },
    {
      text: "İstasyon Tanımlama",
      active: true,
    },
  ],
  trainSetMappingListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Nesne - Vagon Yönetimi",
      href: "#",
    },
    {
      text: "Tren Seti Aktarma Şablonu",
      active: true,
    },
  ],
  carListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Nesne - Vagon Yönetimi",
      href: "#",
    },
    {
      text: "Vagon Tipi Yönetimi",
      active: true,
    },
  ],
  carCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Nesne - Vagon Yönetimi",
      href: "#",
    },
    {
      text: "Vagon Tipi Yönetimi",
      to: "/vagon-tipi-yonetimi",
    },
    {
      text: "Vagon Tanımlama",
      active: true,
    },
  ],
  seatMapListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Nesne - Vagon Yönetimi",
      href: "#",
    },
    {
      text: "Vagon Tasarımı Yönetimi",
      active: true,
    },
  ],
  seatMapCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Nesne - Vagon Yönetimi",
      href: "#",
    },
    {
      text: "Vagon Tasarımı Yönetimi",
      to: "/vagon-tasarimi-yonetimi",
    },
    {
      text: "Vagon Tasarımı Tanımlama",
      active: true,
    },
  ],
  carGroupListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Nesne - Vagon Yönetimi",
      href: "#",
    },
    {
      text: "Vagon Grubu Yönetimi",
      active: true,
    },
  ],
  seatMapConnectingTemplateListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Nesne - Vagon Yönetimi",
      href: "#",
    },
    {
      text: "Vagon Aktarma Şablonu",
      active: true,
    },
  ],
  seatMapConnectingTemplateCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Nesne - Vagon Yönetimi",
      href: "#",
    },
    {
      text: "Vagon Aktarma Şablonu",
      to: "/vagon-aktarma-sablonu",
    },
    {
      text: "Vagon Aktarımı Tanımlama",
      active: true,
    },
  ],
  itemCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Nesne - Vagon Yönetimi",
      href: "#",
    },
    {
      text: "Nesne Yönetimi",
      to: "/nesne-yonetimi",
    },
    {
      text: "Nesne Tanımlama",
      active: true,
    },
  ],
  itemGroupListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Nesne - Vagon Yönetimi",
      href: "#",
    },
    {
      text: "Nesne Grup Şablonu",
      active: true,
    },
  ],
  itemGroupCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Nesne - Vagon Yönetimi",
      href: "#",
    },
    {
      text: "Nesne Grup Şablonu",
      to: "/nesne-grup-sablonu",
    },
    {
      text: "Nesne Gruplama",
      active: true,
    },
  ],
  itemListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Nesne - Vagon Yönetimi",
      href: "#",
    },
    {
      text: "Nesne Yönetimi",
      active: true,
    },
  ],
  itemTypeCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Nesne - Vagon Yönetimi",
      href: "#",
    },
    {
      text: "Nesne Tipi Yönetimi",
      to: "/nesne-tipi-yonetimi",
    },
    {
      text: "Nesne Tipi Tanımlama",
      active: true,
    },
  ],
  itemGroupTypeCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Nesne Grup Tipi Tanımlama",
      active: true,
    },
  ],
  itemGroupTypeListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Nesne Grup Tipi Yönetimi",
      active: true,
    },
  ],
  itemTypeListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Nesne - Vagon Yönetimi",
      href: "#",
    },
    {
      text: "Nesne Tipi Yönetimi",
      active: true,
    },
  ],
  itemPropertyCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Nesne - Vagon Yönetimi",
      href: "#",
    },
    {
      text: "Nesne Özellik Yönetimi",
      to: "/nesne-ozellik-yonetimi",
    },
    {
      text: "Nesne Özellik Tanımlama",
      active: true,
    },
  ],
  itemPropertyListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Nesne - Vagon Yönetimi",
      href: "#",
    },
    {
      text: "Nesne Özellik Yönetimi",
      active: true,
    },
  ],
  lineCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Hat Yönetimi",
      to: "/hat-yonetimi",
    },
    {
      text: "Hat Oluşturma",
      active: true,
    },
  ],
  lineListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Hat Yönetimi",
      active: true,
    },
  ],
  orerCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Orer Yönetimi",
      to: "/zaman-cizelgesi-yonetimi",
    },
    {
      text: "Orer Tanımlama",
      active: true,
    },
  ],
  orerListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Orer İşlemleri",
      active: true,
    },
  ],
  parkourBasedPriceCreateView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Fiyatlandırma Yönetimi",
      href: "#",
    },
    {
      text: "Parkur Bazlı Fiyatlandırma Yönetimi",
      to: "/parkur-bazli-fiyatlandirma-tanimlama",
    },
    {
      text: "Parkur Bazlı Fiyat Tanımlama",
      active: true,
    },
  ],
  parkourBasedDynamicPriceCreateView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Fiyatlandırma Yönetimi",
      href: "#",
    },
    {
      text: "Parkur Bazlı Fiyatlandırma Yönetimi",
      to: "/parkur-bazli-fiyatlandirma-tanimlama",
    },
    {
      text: "Parkur Bazlı Dinamik Fiyat Tanımlama",
      active: true,
    },
  ],
  additionalServiceParkourBasedPricingView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Fiyatlandırma Yönetimi",
      href: "#",
    },
    {
      text: "Ek Hizmet Yönetimi",
      href: "#",
    },
    {
      text: "Ek Hizmet Parkur Bazlı Fiyat Tanımlama",
      active: true,
    },
  ],
  additionalServiceKilometricBasedPricingView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Fiyatlandırma Yönetimi",
      href: "#",
    },
    {
      text: "Ek Hizmet Yönetimi",
      href: "#",
    },
    {
      text: "Ek Hizmet Kilometre Bazlı Fiyat Tanımlama",
      active: true,
    },
  ],
  SSRParkourBasedPricingView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Fiyatlandırma Yönetimi",
      href: "#",
    },
    {
      text: "Özel Hizmet Yönetimi",
      href: "#",
    },
    {
      text: "Özel Hizmet Parkur Bazlı Fiyat Tanımlama",
      active: true,
    },
  ],
  SSRKilometricBasedPricingView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Fiyatlandırma Yönetimi",
      href: "#",
    },
    {
      text: "Özel Hizmet Yönetimi",
      href: "#",
    },
    {
      text: "Özel Hizmet Kilometre Bazlı Fiyat Tanımlama",
      active: true,
    },
  ],
  parkourBasedPriceListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Parkur Bazlı Fiyat Yönetimi",
      active: true,
    },
  ],
  kilometerBasedPriceListView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Fiyatlandırma Yönetimi",
      href: "#",
    },
    {
      text: "Kilometre Bazlı Fiyat Yönetimi",
      href: "#",
    },
    {
      text: "Kilometre Bazlı Fiyat Tanımlama",
      active: true,
    },
  ],
  kilometerBasedDynamicPriceListView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Fiyatlandırma Yönetimi",
      href: "#",
    },
    {
      text: "Kilometre Bazlı Fiyat Yönetimi",
      to: "/kilometre-bazli-fiyatlandirma-tanimlama",
    },
    {
      text: "Kilometre Bazlı Dinamik Fiyat Tanımlama",
      active: true,
    },
  ],
  segmentCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Segment Tanımlama",
      active: true,
    },
  ],
  segmentListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Segment Yönetimi",
      active: true,
    },
  ],
  hardwareListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "İstasyon Yönetimi",
      href: "#",
    },
    {
      text: "Donanım Yönetimi",
      active: true,
    },
  ],
  physicalPropertyListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "İstasyon Yönetimi",
      href: "#",
    },
    {
      text: "İstasyon Fiziksel Özellik Yönetimi",
      active: true,
    },
  ],
  stationStatusListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "İstasyon Yönetimi",
      href: "#",
    },
    {
      text: "İstasyon Durum Yönetimi",
      active: true,
    },
  ],
  stationTypeListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "İstasyon Yönetimi",
      href: "#",
    },
    {
      text: "İstasyon Tipi Yönetimi",
      active: true,
    },
  ],
  equivalentStationListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "İstasyon Yönetimi",
      href: "#",
    },
    {
      text: "Eşlenik İstasyon Yönetimi",
      active: true,
    },
  ],
  trainWhereStationListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "İstasyon Yönetimi",
      href: "#",
    },
    {
      text: "Trenim Nerede İstasyon Yönetimi",
      active: true,
    },
  ],
  timeScheduleCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Zaman Tarife Tanımlama",
      active: true,
    },
  ],
  timeScheduleListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Zaman Tarife Yönetimi",
      active: true,
    },
  ],
  zoneBasedPriceCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Zone Bazlı Fiyat Tanımlama",
      active: true,
    },
  ],
  zoneBasedPriceListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Zone Bazlı Fiyat Yönetimi",
      active: true,
    },
  ],
  zoneListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Zone Yönetimi",
      active: true,
    },
  ],
  mainUnitListView: [
    {
      text: "Birim Personel İşlemleri",
      href: "#",
    },
    {
      text: "Ana Birim Yönetimi",
      active: true,
    },
  ],
  UnitTreeView: [
    {
      text: "Birim Personel İşlemleri",
      href: "#",
    },
    {
      text: "Birim Ağacı",
      active: true,
    },
  ],
  mainUnitCreateView: [
    {
      text: "Birim Personel İşlemleri",
      href: "#",
    },
    {
      text: "Ana Birim Yönetimi",
      to: "/ana-birim-yonetimi",
    },
    {
      text: "Ana Birim Tanımlama",
      active: true,
    },
  ],
  ticketClassRulesListView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Envanter Yönetimi",
      href: "#",
    },
    {
      text: "Bilet Sınıf Kural Yönetimi",
      active: true,
    },
  ],
  ticketClassRulesCreateView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Envanter Yönetimi",
      href: "#",
    },
    {
      text: "Bilet Sınıf Kural Yönetimi",
      to: "/bilet-sinif-kural-yonetimi",
    },
    {
      text: "Bilet Sınıf Kuralları Tanımlama",
      active: true,
    },
  ],
  classListListView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Envanter Yönetimi",
      href: "#",
    },
    {
      text: "Sınıf Yönetimi",
      active: true,
    },
  ],
  classCreateView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Envanter Yönetimi",
      href: "#",
    },
    {
      text: "Sınıf Yönetimi",
      to: "/sinif-yonetimi",
    },
    {
      text: "Ana Sınıf Tanımlama",
      active: true,
    },
  ],
  userListView: [
    {
      text: "Birim Personel İşlemleri",
      href: "#",
    },
    {
      text: "Kullanıcı Listeleme",
      active: true,
    },
  ],
  userAccountDataListView: [
    {
      text: "Kullanıcı İşlemleri",
      href: "#",
    },
    {
      text: "Kullanıcı Hesap Verilerini Sorgulama",
      active: true,
    },
  ],
  titleListView: [
    {
      text: "Birim Personel İşlemleri",
      href: "#",
    },
    {
      text: "Ünvan Yönetimi",
      active: true,
    },
  ],
  fareFamilyListView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Envanter Yönetimi",
      href: "#",
    },
    {
      text: "Ücret Ailesi Yönetimi",
      active: true,
    },
  ],
  priceListView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Fiyat Tanımlama",
      active: true,
    },
  ],
  trainCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Tren Yönetimi",
      href: "#",
    },
    {
      text: "Tren Yönetimi",
      to: "/tren-yonetimi",
    },
    {
      text: "Tren Tanımlama",
      active: true,
    },
  ],
  trainListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Tren Yönetimi",
      href: "#",
    },
    {
      text: "Tren Yönetimi",
      active: true,
    },
  ],
  passengerTypeListView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Fiyatlandırma Yönetimi",
      href: "#",
    },
    {
      text: "Tarife Yönetimi",
      active: true,
    },
  ],
  passengerTypeCreateView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Fiyatlandırma Yönetimi",
      href: "#",
    },
    {
      text: "Tarife Yönetimi",
      to: "/tarife-yonetimi",
    },
    {
      text: "Tarife Tanımlama",
      active: true,
    },
  ],
  additionalServiceListView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Fiyatlandırma Yönetimi",
      href: "#",
    },
    {
      text: "Ek Hizmet Yönetimi",
      active: true,
    },
  ],
  additionalServiceCreateView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Fiyatlandırma Yönetimi",
      href: "#",
    },
    {
      text: "Ek Hizmet Yönetimi",
      to: "/ek-hizmet-yonetimi",
    },
    {
      text: "Ek Hizmet Tanımlama",
      active: true,
    },
  ],
  additionalServiceTypeListView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Fiyatlandırma Yönetimi",
      href: "#",
    },
    {
      text: "Ek Hizmet Türü Yönetimi",
      active: true,
    },
  ],
  additionalServicePricingListView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Fiyatlandırma Yönetimi",
      href: "#",
    },
    {
      text: "Ek Hizmet Fiyat Yönetimi",
      active: true,
    },
  ],
  additionalServicePricingCreateView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Fiyatlandırma Yönetimi",
      href: "#",
    },
    {
      text: "Ek Hizmet Fiyat Yönetimi",
      to: "/ek-hizmet-fiyat-yonetimi",
    },
    {
      text: "Ek Hizmet Fiyat Tanımlama",
      active: true,
    },
  ],
  specialServiceListView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Fiyatlandırma Yönetimi",
      href: "#",
    },
    {
      text: "Özel Hizmet Yönetimi",
      href: "#",
    },
    {
      text: "Özel Hizmet Yönetimi",
      active: true,
    },
  ],
  specialServiceCreateView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Fiyatlandırma Yönetimi",
      href: "#",
    },
    {
      text: "Özel Hizmet Yönetimi",
      to: "/ozel-servis-hizmeti-yonetimi",
    },
    {
      text: "Özel Hizmet Tanımlama",
      active: true,
    },
  ],
  specialServiceRequestCategoryListView: [
    {
      text: "Fiyatlandırma İşlemleri",
      href: "#",
    },
    {
      text: "Fiyatlandırma Yönetimi",
      href: "#",
    },
    {
      text: "Özel Hizmet Yönetimi",
      href: "#",
    },
    {
      text: "Özel Hizmet Türü",
      active: true,
    },
  ],
  // commissionTableListView: [
  //   {
  //     text: "Acente İşlemleri",
  //     href: "#",
  //   },
  //   {
  //     text: "Komisyon Tablosu Yönetimi",
  //     active: true,
  //   },
  // ],
  // commissionTableCreateView: [
  //   {
  //     text: "Acente İşlemleri",
  //     href: "#",
  //   },
  //   {
  //     text: "Komisyon Tablosu Yönetimi",
  //     to:"/komisyon-tablosu-yonetimi"
  //   },
  //   {
  //     text: "Komisyon Tablosu Tanımlama",
  //     active: true,
  //   },
  // ],
  resourceGroupListView: [
    {
      text: "Birim Personel Yönetimi",
      href: "#",
    },
    {
      text: "Yetki Grup Yönetimi",
      active: true,
    },
  ],
  resourceGroupCreateView: [
    {
      text: "Birim Personel Yönetimi",
      href: "#",
    },
    {
      text: "Yetki Grup Yönetimi",
      to: "/yetki-grup-yonetimi",
    },
    {
      text: "Yetki Grup Tanımlama",
      active: true,
    },
  ],
  trainSetCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Tren Yönetimi",
      href: "#",
    },
    {
      text: "Tren Seti Yönetimi",
      to: "/tren-seti-yonetimi",
    },
    {
      text: "Tren Seti Tanımlama",
      active: true,
    },
  ],
  trainSetListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Tren Yönetimi",
      href: "#",
    },
    {
      text: "Tren Seti Yönetimi",
      active: true,
    },
  ],
  trainConnectingCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Tren Yönetimi",
      href: "#",
    },
    {
      text: "Aktarmalı Tren Yonetimi",
      to: "/aktarmali-tren-yonetimi",
    },
    {
      text: "Aktarmalı Tren Tanımlama",
      active: true,
    },
  ],
  trainConnectingListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Tren Yönetimi",
      href: "#",
    },
    {
      text: "Aktarmalı Tren Yonetimi",
      active: true,
    },
  ],
  trainRegionListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Tren Yönetimi",
      href: "#",
    },
    {
      text: "Tren Bölge Yonetimi",
      active: true,
    },
  ],
  connectedTrainDiscountCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Tren Yönetimi",
      href: "#",
    },
    {
      text: "Aktarmalı Tren İndirimi Yönetimi",
      to: "/aktarmali-tren-indirimi-yonetimi",
    },
    {
      text: "Aktarmalı Tren İndirimi Tanımlama",
      active: true,
    },
  ],
  connectedTrainDiscountListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Tren Yönetimi",
      href: "#",
    },
    {
      text: "Aktarmalı Tren İndirimi Yönetimi",
      active: true,
    },
  ],
  salesTransactionsListView: [
    {
      text: "Satış İşlemleri",
      href: "#",
    },
    {
      text: "Bilet Satış",
      active: true,
    },
  ],
  bulkTicketing: [
    {
      text: "Satış İşlemleri",
      href: "#",
    },
    {
      text: "Toplu Biletleme",
      active: true,
    },
  ],
  messageTranslationCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Hata Mesajı Çeviri Yönetimi",
      to: "/hata-mesaji-ceviri-yonetimi",
    },
    {
      text: "Çeviri Ekleme",
      active: true,
    },
  ],
  announcementCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Duyuru Yönetimi",
      to: "/duyuru-yonetimi",
    },
    {
      text: "Duyuru Ekleme",
      active: true,
    },
  ],
  authorizationManagementCreateView: [
    {
      text: "Birim Personel Yönetimi",
      href: "#",
    },
    {
      text: "Rol Yönetimi",
      active: true,
    },
  ],
  agentListView: [
    {
      text: "Acente İşlemleri",
      href: "#",
    },
    {
      text: "Acente Yönetimi",
      active: true,
    },
  ],
  agentCreateView: [
    {
      text: "Acente İşlemleri",
      href: "#",
    },
    {
      text: "Acente Yönetimi",
      to: "/acente-yonetimi",
    },
    {
      text: "Acente Tanımlama",
      active: true,
    },
  ],
  AgentPaymentAccountClosingView: [
    {
      text: "Acente İşlemleri",
      href: "#",
    },
    {
      text: "Acente Ödeme İşlemleri",
      active: true,
    },
  ],
  AgentMultipleCloseAccountPeriodView: [
    {
      text: "Acente İşlemleri",
      href: "#",
    },
    {
      text: "Acente Toplu Hesap Kapatma İşlemleri",
      active: true,
    },
  ],
  AgentAccountingPeriodTransactions: [
    {
      text: "Acente İşlemleri",
      href: "#",
    },
    {
      text: "Acente Dönem İşlemleri",
      active: true,
    },
  ],
  AgencySalesReportsView: [
    {
      text: "Acente İşlemleri",
      href: "#",
    },
    {
      text: "Acente Satış Raporları",
      active: true,
    },
  ],
  AgencyEndOfPeriodReportingProceduresView: [
    {
      text: "Acente İşlemleri",
      href: "#",
    },
    {
      text: "Acente Dönem Sonu Raporlama İşlemleri",
      active: true,
    },
  ],
  KKYAccountTransferView: [
    {
      text: "Gişe İşlemleri",
      href: "#",
    },
    {
      text: "KKY'ye Hesap Aktarımı",
      active: true,
    },
  ],
  PersonnelAccountClosingView: [
    {
      text: "Gişe İşlemleri",
      href: "#",
    },
    {
      text: "Hesap Durumu Görüntüleme",
      href: "#",
    },
    {
      text: "Personel Hesap Kapatma",
      active: true,
    },
  ],
  AccountClosureConfirmationView: [
    {
      text: "Gişe İşlemleri",
      href: "#",
    },
    {
      text: "Hesap Durumu Görüntüleme",
      href: "#",
    },
    {
      text: "Hesap Kapatma Onay",
      active: true,
    },
  ],
  AdditionalRevenueListView: [
    {
      text: "Gişe Yönetimi",
      href: "#",
    },
    {
      text: "Ek Gelir Yönetimi",
      href: "#",
    },
    {
      text: "Ek Gelir Tanım Yönetimi",
      active: true,
    },
  ],
  AdditionalRevenueCreateView: [
    {
      text: "Gişe Yönetimi",
      href: "#",
    },
    {
      text: "Ek Gelir Yönetimi",
      href: "#",
    },
    {
      text: "Ek Gelir Ön Tanımlama",
      active: true,
    },
  ],
  AdditionalRevenueEntranceListView: [
    {
      text: "Gişe Yönetimi",
      href: "#",
    },
    {
      text: "Ek Gelir Yönetimi",
      href: "#",
    },
    {
      text: "Ek Gelir Girişi",
      active: true,
    },
  ],
  AdditionalRevenueEntranceCreateView: [
    {
      text: "Gişe Yönetimi",
      href: "#",
    },
    {
      text: "Ek Gelir Yönetimi",
      href: "#",
    },
    {
      text: "Ek Gelir Girişi Tanımlama",
      active: true,
    },
  ],
  boxOfficeListView: [
    {
      text: "Gişe İşlemleri",
      href: "#",
    },
    {
      text: "Gişe Yönetimi",
      active: true,
    },
  ],
  BoxOfficeCreateView: [
    {
      text: "Gişe İşlemleri",
      href: "#",
    },
    {
      text: "Gişe Yönetimi",
      to: "/gise-yonetimi",
    },
    {
      text: "Gişe Tanımlama",
      active: true,
    },
  ],
  CustomerCreateView: [
    {
      text: "Yolcu İşlemleri",
      href: "#",
    },
    {
      text: "Müşteri Yönetimi",
      to: "/musteri-yonetimi",
    },
    {
      text: "Müşteri Tanımlama",
      active: true,
    },
  ],
  CustomerListView: [
    {
      text: "Yolcu İşlemleri",
      href: "#",
    },
    {
      text: "Müşteri Yönetimi",
      active: true,
    },
  ],
  CustomerPurchaseHistoryView: [
    {
      text: "Müşteri Yönetimi",
      href: "#",
    },
    {
      text: "Müşteri Satın Alma Geçmişi",
      active: true,
    },
  ],
  CustomerConnectedDevicesView: [
    {
      text: "Müşteri Yönetimi",
      href: "#",
    },
    {
      text: "Bağlı Cihazlar",
      active: true,
    },
  ],
  MessageTranslationListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Hata Mesajı Çeviri Yönetimi",
      active: true,
    },
  ],
  AnnouncementListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Duyuru Yönetimi",
      active: true,
    },
  ],
  UserCreateView: [
    {
      text: "Birim Personel Yönetimi",
      href: "#",
    },
    {
      text: "Kullanıcı Listeleme",
      to: "kullanici-listeleme",
    },
    {
      text: "Kullanıcı Tanımlama",
      active: true,
    },
  ],
  QuotaCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Kontenjan Yönetimi",
      to: "/kontenjan-yonetimi",
    },
    {
      text: "Kontenjan Yönetimi",
      to: "/kontenjan-yonetimi",
    },
    {
      text: "Kontenjan Tanımlama",
      active: true,
    },
  ],
  QuotaListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Kontenjan Yönetimi",
      to: "/kontenjan-yonetimi",
    },
    {
      text: "Kontenjan Yönetimi",
      active: true,
    },
  ],
  TrainQuotaCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Kontenjan Yönetimi",
      to: "/kontenjan-yonetimi",
    },
    {
      text: "Tren Kontenjan İşlemleri",
      active: true,
    },
  ],
  SeferQuotaCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Kontenjan Yönetimi",
      to: "/kontenjan-yonetimi",
    },
    {
      text: "Sefer Kontenjan İşlemleri",
      active: true,
    },
  ],
  SeferManagementListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Sefer İşlemleri",
      active: true,
    },
  ],
  subscriptionPackageListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Abonmanlık Paket Yönetimi",
      active: true,
    },
  ],
  subscriptionPackageCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Abonmanlık Paket Yönetimi",
      to: "/abonmanlik-paket-yonetimi",
    },
    {
      text: "Abonman Paket Tanımlama",
      active: true,
    },
  ],
  packageSaleView: [
    {
      text: "Satış İşlemleri",
      href: "#",
    },
    {
      text: "Paket Satış",
      active: true,
    },
  ],
  discountPackageListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "İndirim Paket Yönetimi",
      active: true,
    },
  ],
  discountPackageCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "İndirim Paket Yönetimi",
      to: "/indirim-paket-yonetimi",
    },
    {
      text: "İndirim Paket Tanımlama",
      active: true,
    },
  ],
  parameterCreateView: [
    {
      text: "Yolcu İşlemleri",
      href: "#",
    },
    {
      text: "Parametre Yönetimi",
      to: "/parametre-yonetimi",
    },
    {
      text: "Parametre Tanımlama",
      active: true,
    },
  ],
  parameterListView: [
    {
      text: "Yolcu İşlemleri",
      href: "#",
    },
    {
      text: "Parametre Yönetimi",
      active: true,
    },
  ],
  ticketTransactions: [
    {
      text: "Yolcu İşlemleri",
      href: "#",
    },
    {
      text: "Bilet İşlemleri",
      active: true,
    },
  ],
  notificationListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Bilgilendirme Yönetimi",
      href: "#",
    },
    {
      text: "Bildirim Planlama",
      active: true,
    },
  ],
  notificationCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Bilgilendirme Yönetimi",
      href: "#",
    },
    {
      text: "Bildirim Planlama",
      to: "/bildirim-planlama",
    },
    {
      text: "Bildirim Tanımlama",
      active: true,
    },
  ],
  informationListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Bilgilendirme Yönetimi",
      active: true,
    },
  ],
  informationCreateView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Bilgilendirme Yönetimi",
      to: "/bilgilendirme-yonetimi",
    },
    {
      text: "Bilgilendirme Tanımlama",
      active: true,
    },
  ],
  memberBlackListProcedures: [
    {
      text: "Üye İşlemleri",
      href: "#",
    },
    {
      text: "Üye Karaliste Yonetimi",
      active: true,
    },
  ],
  blackListRuleView: [
    {
      text: "Üye İşlemleri",
      href: "#",
    },
    {
      text: "Kara Liste Kural Yonetimi",
      active: true,
    },
  ],
  blackListRuleCreateView: [
    {
      text: "Üye İşlemleri",
      href: "#",
    },
    {
      text: "Kara Liste Kural Yonetimi",
      to: "/kara-liste-kural-yonetimi",
    },
    {
      text: "Kara Liste Kural Tanımlama",
      active: true,
    },
  ],
  militaryUnitListView: [
    {
      text: "Askeri İşlemler",
      href: "#",
    },
    {
      text: "Askeri Birlikler",
      active: true,
    },
  ],
  muhtiraDownloadListView: [
    {
      text: "Askeri İşlemler",
      href: "#",
    },
    {
      text: "Muhtıra Görüntüleme / İndirme",
      active: true,
    },
  ],
  muhtiraTransactionsView: [
    {
      text: "Askeri İşlemler",
      href: "#",
    },
    {
      text: "Muhtıra İşlemleri",
      active: true,
    },
  ],
  corporateBasedTransactions: [
    {
      text: "Yolcu İşlemleri",
      href: "#",
    },
    {
      text: "Kurum Kaynaklı İade",
      active: true,
    },
  ],
  internationalTicketTransactions: [
    {
      text: "Interrail Bilet", // TYTP-1309: eski hali "Eurail Bilet"
      active: true,
    },
  ],
  internationalTicketCardDetails: [
    {
      text: "Interrail Bilet", // TYTP-1309: eski hali "Eurail Bilet"
      href: "/interrail-eurail",
    },
    {
      text: "Kart Detayları",
      active: true,
    },
  ],
  internationalTicketPassengerInformation: [
    {
      text: "Interrail Bilet", // TYTP-1309: eski hali "Eurail Bilet"
      href: "/interrail-eurail",
    },
    {
      text: "Yolcu Bilgileri",
      active: true,
    },
  ],
  internationalTicketPayment: [
    {
      text: "Interrail Bilet", // TYTP-1309: eski hali "Eurail Bilet"
      href: "/interrail-eurail",
    },
    {
      text: "Ödeme",
      active: true,
    },
  ],
  internationalTicket: [
    {
      text: "Interrail Bilet", // TYTP-1309: eski hali "Eurail Bilet"
      active: true,
    },
  ],
  monthlySalesRejectionReport: [
    {
      text: "Raporlar",
      href: "#",
    },
    {
      text: "Aylık Satış Reddiyat Raporu",
      active: true,
    },
  ],
  priceComparisonReport: [
    {
      text: "Raporlar",
      href: "#",
    },
    {
      text: "Fiyat Karşılaştırma Raporu",
      active: true,
    },
  ],
  trainKmOccupancyReport: [
    {
      text: "Raporlar",
      href: "#",
    },
    {
      text: "Tren Bazında Tren-Km Doluluk Verisi Raporu",
      active: true,
    },
  ],
  evaluationsListView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Kullanıcı Değerlendirmeleri",
      active: true,
    },
  ],
  sendTrainPassengersSms: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Bilgilendirme Yönetimi",
      href: "#",
    },
    {
      text: "Tren Yolcularına Sms Gönder",
      active: true,
    },
  ],
  outgoingReceiptsCreateView: [
    {
      text: "Giden Dekont Üretme",
      active: true,
    },
  ],
  helpMainHeaderView: [
    {
      text: "Yönetici İşlemleri",
      href: "#",
    },
    {
      text: "Yardım Sayfası Yönetimi",
      to: "/yardim-sayfasi-yonetimi",
    },
    {
      text: "Yardım Sayfası Tanımla",
      active: true,
    },
  ],
  lostPropertyStaffOperationsView: [
    {
      text: "Kayıp Eşya",
      href: "#",
    },
    {
      text: "Bulunan Eşya İşlemleri",
      active: true,
    },
  ],
  lostPropertyAdminOperationsView: [
    {
      text: "Kayıp Eşya",
      href: "#",
    },
    {
      text: "Kayıp Eşya Eşleştirme",
      active: true,
    },
  ],
  lostPropertySettingsView: [
    {
      text: "Kayıp Eşya",
      href: "#",
    },
    {
      text: "Kategori ve Ayarlar",
      active: true,
    },
  ],
};
